import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

import { fontColours } from '@/static/colours'


export default /*#__PURE__*/_defineComponent({
  __name: 'ColourSelector',
  props: {
    selectedColour: null,
    disabled: { type: Boolean }
  },
  emits: ["colourSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'colourSelected', colourName: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedColour: string | null,
  disabled: boolean
};






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['colour-selector', { 'colour-selector--disabled': __props.disabled }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fontColours), (colour, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['colour-selector__item', { 'colour-selector__item--selected': colour === __props.selectedColour }]),
        onClick: ($event: any) => (emits('colourSelected', colour))
      }, [
        _createElementVNode("div", {
          class: "colour-selector__item-inner-circle",
          style: _normalizeStyle({backgroundColor: colour})
        }, null, 4)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})